/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemsNewsletterSubscriptions } from '../../models/items-newsletter-subscriptions';

export interface CreateItemsNewsletterSubscriptions$Params {

/**
 * What metadata to return in the response.
 */
  meta?: string;
      body?: (Array<ItemsNewsletterSubscriptions> | ItemsNewsletterSubscriptions)
}

export function createItemsNewsletterSubscriptions(http: HttpClient, rootUrl: string, params?: CreateItemsNewsletterSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'data'?: Array<ItemsNewsletterSubscriptions>;
}>> {
  const rb = new RequestBuilder(rootUrl, createItemsNewsletterSubscriptions.PATH, 'post');
  if (params) {
    rb.query('meta', params.meta, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'data'?: Array<ItemsNewsletterSubscriptions>;
      }>;
    })
  );
}

createItemsNewsletterSubscriptions.PATH = '/items/newsletter_subscriptions';
